import type { TFunction } from "i18next";

export const humanizeDuration = (
  totalSeconds: number,
  t: TFunction,
): string => {
  if (totalSeconds <= 0) {
    return t("regions.detail.duration.second", { count: 0 });
  }
  if (totalSeconds % 3600 === 0) {
    const hours = totalSeconds / 3600;
    return t("regions.detail.duration.hour", { count: hours });
  }
  if (totalSeconds % 60 === 0) {
    const minutes = totalSeconds / 60;
    return t("regions.detail.duration.minute", { count: minutes });
  }
  return t("regions.detail.duration.second", { count: totalSeconds });
};
